defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubCardFooter',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril'
  ],
  function (m) {
    // Context:
    var ClubCardFooter = function (args) {
      var buttons = args.buttons;

      // Return:
      return m('.play-together-club-card-flow-footer', [
        buttons ? m('.play-together-club-card__content-buttons', buttons) : null
      ]);
    };

    // Public functions:
    return ClubCardFooter;
  });
